import { render, staticRenderFns } from "./CheckBoxForm.vue?vue&type=template&id=748427d2&scoped=true&lang=pug&"
import script from "./CheckBoxForm.vue?vue&type=script&lang=js&"
export * from "./CheckBoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748427d2",
  null
  
)

export default component.exports